<template>
  <div class="web-body">
    <!-- 头部 -->
    <web-header></web-header>
    <!-- 内容 start -->
    <router-view class="web-container"></router-view>
    <!-- 内容 end -->
    <!-- 底部 -->
    <web-footer></web-footer>
    <web-topping></web-topping>

    <!-- 举报入口 -->
    <div class="report-box" v-if="$store.state.sys.reportShow">
      <img src="../assets/images/common/close.png" alt="" class="report-close" @click="closeReport">
      <div class="report-items">
        举报电话：
        <p>0358-5300029</p>
      </div>
      <div class="report-items">
        投诉邮箱：
        <p>zyrmtzx@163.com</p>
      </div>
    </div>
  </div>
</template>

<script>
  import webHeader from "@/components/Header.vue"
  import webFooter from "@/components/Footer.vue"
  export default {
    name: "Home",
    components: {
      webHeader,
      webFooter
    },
    methods: {
      // 关闭举报入口
      closeReport() {
        this.$store.dispatch('reportClose', false);
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .web-container {
    padding: 30px 0;
    flex: 1;
  }

  .web-body {
    display: flex;
    min-height: 100vh;
    flex-direction: column;
    background-color: #F8F8F8;
  }

  .report-box {
    padding: 15px 20px;
    background-color: #FFFFFF;
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 9999;
    border-radius: 4px;
    font-size: 18px;
    box-shadow: 3px 3px 15px 1.7px rgba(28, 28, 28, 0.29);
  }

  .report-close {
    width: 30px;
    height: 30px;
    cursor: pointer;
    position: absolute;
    top: 2px;
    right: 2px;
  }

  .report-box p {
    user-select: all;
    margin-left: 20px;
    margin-top: 5px;
  }

  .report-items {
    margin-top: 10px;
  }

  @media screen and (max-width: 800px) {
    .web-container {
      padding: 20px 0;
    }

    .report-box {
      padding: 10px;
      font-size: 14px;
    }

    .report-close {
      width: 20px;
      height: 20px;
    }

    .report-box p {
      margin-left: 16px;
      margin-top: 2px;
    }

    .report-items {
      margin-top: 6px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Body.vue